import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import { Grid, Slider, Box } from '@material-ui/core';
import Typo from '../../components/CustomTypo';
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil';
import { getAppCfg } from '../../utils/common';
import ProgressBar from '../../components/ProgressBar';
import defaultTheme,{ commonColor } from '../../theme.css';
import { GiftIcon, StarIcon } from '../../components/icons';

const heightCoverItem = 180
const heightContentItem = 140
const styles = theme => ({
    container: {
        padding: theme.spacing(3),
        cursor: 'pointer',
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(2,3,2,3),
        },
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2,3,2,3),
        },
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1,2,1,2),
        },
    },
    item: {
        border: '0px solid',
        borderColor: theme.palette.background.transparent,
        borderRadius: theme.spacing(4),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        //height: 280,
        //backgroundColor: theme.palette.background.secondary,
        position: 'relative',
    },
    image_container: {
        borderBottomWidth: 1,
        height: heightCoverItem + heightContentItem,
        borderRadius: theme.spacing(4),
    },
    item_cover: {
        width: '100%',
        height: heightCoverItem + heightContentItem,
        objectFit: 'cover',
        borderRadius: theme.spacing(4),
       // borderTopRightRadius: theme.spacing(4),
    },
    item_content: {
        padding: theme.spacing(6,4,4,4),
        backgroundColor: theme.palette.background.secondary,
        borderBottomLeftRadius: theme.spacing(4),
        borderBottomRightRadius: theme.spacing(4),
        //height: heightContentItem,
        width:'100%',
        position: 'absolute',
        bottom: 0,
    },
    item_circle: {
        width: theme.spacing(12),
        height: theme.spacing(12),
        borderRadius: theme.spacing(12),
        boxShadow: ' -1px 2px 14px -5px rgba(0,0,0,0.75)',
        border: '0px solid',
        borderColor: theme.palette.background.transparent,
        backgroundColor: theme.palette.background.secondary,
        position: 'absolute',
        top: heightCoverItem + theme.spacing(4),
        left: theme.spacing(10),
        justifyContent: 'center',
        alignItems: 'center',
        display: "flex",
        zIndex: 99
    },
    itemImageSmall: {
        width: theme.spacing(10),
        height: theme.spacing(10),
        borderRadius: theme.spacing(10),
        //objectFit: 'cover',
        resizeMode: 'contain'
    },
    item_star: {
        position: 'absolute',
        top: heightCoverItem + theme.spacing(4),
        right: theme.spacing(10),
        zIndex: 99
    },
});

function OfferItem(props){
    const { classes, item, onShowOfferDetail } = props;
    var isShowProgress = item.performance_enabled && item.performance_data ? true : false
    //console.log('OfferItem==========', item)
    const app_config_creatives = getAppCfg().creatives?getAppCfg().creatives:null
    const creatives = item.owned_by&&item.owned_by.creatives?item.owned_by.creatives:app_config_creatives

    return (
        <Grid xs={12} sm={6} md={6} lg={4} xl={3} item container className={classes.container} onClick={() => onShowOfferDetail(item)}>
            <Grid xs={12} item className={classes.item}>
                <Grid item container xs={12} justify='center' className={classes.image_container}>
                    <OfferItemImage classes={classes} image={dataUtil.getImageByUsageTypePortal(item.creatives, usage_type.offer_detail)} />
                </Grid>
                <Grid className={classes.item_circle}>
                    <MerchantImage classes={classes} image={dataUtil.getImageByUsageTypePortal(creatives, usage_type.offer_detail_merchant)} />
                </Grid>
                {item.is_featured && <Grid className={classes.item_star}>
                    <StarIcon />
                </Grid>}
                <Grid xs={12} item className={classes.item_content}>
                    <Typo variant='h6' >{item.owned_by.name}</Typo>
                    <Typo mg_top_xs variant='body1'>{item.name}</Typo>

                    {isShowProgress && <Grid xs={12} item justify='center' container>
                        <Grid xs={12} item container justify='center'>
                            <Typo mg_top_xs variant='body1'>{item.performance_data && item.performance_data.percentage_progress ? item.performance_data.percentage_progress.toFixed(0) : 0}{"%"}</Typo>
                        </Grid>
                        <Grid xs={12} item style={{ marginTop: -10 }}>
                            <ProgressBar
                                completed={item.performance_data && item.performance_data.percentage_progress ? item.performance_data.percentage_progress : 0}
                                filledColor={defaultTheme.palette.background.primary}
                                bgcolor={defaultTheme.palette.border.primary}
                            />
                        </Grid>
                    </Grid>}
                </Grid>
            </Grid>
        </Grid>

    );
}

function OfferItemImage(props) {
    const { classes, creatives, image } = props;
    var imageObject = null;
    // if (creatives && creatives.length > 0) {
    //     imageObject = creatives[0];
    // }
    if (image) {
        return <img src={image.url} className={classes.item_cover} />
    } else {
        return (
            <Grid item xs={12}container  alignItems='center' justify='center' className={classes.item_cover} >
                <GiftIcon/>
            </Grid>
        )
    }
}
function MerchantImage(props) {
    // var creatives = props.creatives;

    // var imageObject = null;
    // if (creatives && creatives.length > 0) {
    //     imageObject = creatives[0];
    // }
    var image = props.image;
    if (image) {
        return <img src={image.url} className={props.classes.itemImageSmall} />
    } else {
        return (
            <div>
            </div>
            // <View style={home_styles.item_container_icon}>
            //     <GiftIcon style={[main_styles.icon_large, main_styles.icon_color_disable]} />
            // </View>
        )
    }
}

export default withStyles(styles)(withTranslation()(OfferItem));